// @flow

import React from 'react';
import bemify from 'bemify-js';

import { Icon, type IconNameType } from '@zapier/common-components';

import Button from 'web-ssr/app/common/components/Button';
import 'web-ssr/app/common/components/IconButton.scss';

import type { Node } from 'react';

import type { KindType } from 'web-ssr/app/common/types';

const bem = bemify('icon-button');

type Props = {
  className?: string,
  children?: Node,
  disabled?: boolean,
  type?: 'submit' | 'reset' | 'button',
  kind?: KindType,
  onClick?: () => void,
  iconBefore?: IconNameType,
  iconAfter?: IconNameType,
};

const IconButton = (props: Props) => {
  const { children, iconBefore, iconAfter, ...buttonProps } = props;

  return (
    <Button {...buttonProps}>
      {iconBefore ? (
        <Icon className={bem('__before')} name={iconBefore} size={15} />
      ) : null}
      {children}
      {iconAfter ? <Icon className={bem('__after')} name={iconAfter} /> : null}
    </Button>
  );
};

export default IconButton;
